import { ISystemGateway } from "core/gateways/mobile-system/system-gateway.dtos";

import { AxiosInstance } from "@bps/http-client";

export class SystemGateway implements ISystemGateway {
  constructor(public api: AxiosInstance) {}
  readonly appConfigPath = "appConfiguration";

  getAppConfig = async () => {
    const res = await this.api.get(this.appConfigPath);

    return res.data;
  };
}
